// @flow

import { useMemo } from 'react';

import { selectCartCurrency } from '@gandi/cart';
import { selectCurrentId } from '@gandi/redux-sharing';

import { selectCountry, selectCurrency } from 'src/Layout/modules/selectors';
import { useQuery } from 'src/helpers/withRouter';
import type { Query } from 'src/helpers/withRouter';
import { useAppSelector } from 'src/hooks/useAppSelector';

export function useCurrency(): string {
  const { country: locationQueryCountry, currency: locationQueryCurrency } =
    useQuery<Query>();

  const currentId = useAppSelector(selectCurrentId);

  const countryProps = useMemo(
    () => ({
      locationQueryCountry,
      orgId: currentId,
    }),
    [locationQueryCountry, currentId],
  );
  const countryCode = useAppSelector(state =>
    selectCountry(state, countryProps),
  );

  const currencyProps = useMemo(
    () => ({
      locationQueryCurrency,
      country: countryCode,
      orgId: currentId,
    }),
    [locationQueryCurrency, countryCode, currentId],
  );

  const naturalCurrency = useAppSelector(state =>
    selectCurrency(state, currencyProps),
  );

  const cartCurrency = useAppSelector(selectCartCurrency);

  return cartCurrency || naturalCurrency;
}
